import { render, staticRenderFns } from "./GExamCreateBaseSettingDateSpan.vue?vue&type=template&id=59fcda1e&scoped=true&"
import script from "./GExamCreateBaseSettingDateSpan.vue?vue&type=script&lang=ts&"
export * from "./GExamCreateBaseSettingDateSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fcda1e",
  null
  
)

export default component.exports